import {attachMessages} from "../../components/survey/messages";
import attachAdvancedSettings from "../../components/survey/attach-advanced-settings";
import execute_on from "../../libs/execute-on";
import {attachFroalaEditor} from "../../plugins/froala-editor";

(function ($) {
    execute_on('survey.opening.edit', function () {
        $('.idVerificationSwitch').on('click', function(e) {
            const isChecked = $(this).find('input').prop('checked');
            $(this).parents('#idVerificationSection').find('#idVerificationDrop').toggleClass('hide', !isChecked);
            $(this).parents('form').find('#id-verification-messages').toggleClass('hide', !isChecked);
        });

        //show gender questions
        $('.add-gender').on('change', function (e) {
            const isChecked = $(this).prop('checked');
            $(this).parents('.gender-question').find('.gender-form').toggleClass('hide', !isChecked);

        });

        //show age questions
        $('.add-age').on('change', function (e) {
            const isChecked = $(this).prop('checked');
            $(this).parents('.age-question').find('.age-form').toggleClass('hide', !isChecked);
        });

        //adding up the percentages to 100
        $('.sum-to-100 input').on("change", function() {
            const changedEventFieldId = $(this).attr('id');
            const $maleField          = $('.sum-to-100.percent-male input');
            const maleFieldId         = $maleField.attr('id');
            const maleFieldValue      = $maleField.val();
            const $femaleField        = $('.sum-to-100.percent-female input');
            const femaleFieldValue    = $femaleField.val();

            if (changedEventFieldId === maleFieldId) {
                $femaleField.val(100 - maleFieldValue);

                return;
            }

            $maleField.val(100 - femaleFieldValue);
        });

        //set the value of age proportions so that the sum equals 100
        $('.sum-age-proportions-to-100 input').on("change", function () {
            const changedEventFieldId = $(this).attr('id');
            const $youngerField       = $('.sum-to-100.percent-younger input');
            const youngerFieldId      = $youngerField.attr('id');
            const youngFieldValue     = $youngerField.val();
            const $olderField         = $('.sum-to-100.percent-older input');
            const olderFieldValue     = $olderField.val();

            if (changedEventFieldId === youngerFieldId) {
                $olderField.val(100 - youngFieldValue);

                return;
            }

            $youngerField.val(100 - olderFieldValue);
        });

        //age group validation
        const $youngerLow = $('#younger-low-limit');
        const $youngerUp = $('#younger-up-limit');
        const $olderLow = $('#older-low-limit');
        const $olderUp = $('#older-up-limit');

        $youngerLow.on('change', function() {
            $(this).val(
                Math.max(
                    0,
                    Math.min(
                        parseInt($(this).val(), 10),
                        parseInt($youngerUp.val(), 10)-1
                    )
                )
            );
        });

        $youngerUp.on('change', function() {
            $(this).val(
                Math.max(
                    parseInt($youngerLow.val(), 10)+1,
                    Math.min(
                        parseInt($(this).val(), 10),
                        parseInt($olderLow.val(), 10)-1
                    )
                )
            );
        });

        $olderLow.on('change', function() {
            $(this).val(
                Math.max(
                    parseInt($youngerUp.val(), 10) +1,
                    Math.min(
                        parseInt($(this).val(), 10),
                        parseInt($olderUp.val(), 10)-1
                    )
                )
            );
        });

        $olderUp.on('change', function() {
            $(this).val(
                Math.max(
                    parseInt($olderLow.val(), 10)+1,
                    Math.min(
                        parseInt($(this).val(), 10),
                        100,
                    )
                )
            );
        });

        $('#advanced_settings\\.age_proportions_younger_answer').on('change', function() {
            $('.advanced-settings-age-proportions-younger-answer label').text($(this).val());
        });

        $('#advanced_settings\\.age_proportions_older_answer').on('change', function() {
            $('.advanced-settings-age-proportions-older-answer label').text($(this).val());
        });

        $('.answerLength').each(function() {
            $(this).prop('disabled', !$(this).parents('.lengthDisabled').find('.is_answer_limited').is(':checked'));
        })

        attachMessages($('#welcome-messages'));
        attachAdvancedSettings();
        attachFroalaEditor();
    });

    // why is this outside of document.ready?? but when I added this to document.ready it throws errors
    //add dropzone without form around
    Dropzone.autoDiscover = false

    let CSRF_TOKEN = document.querySelector('meta[name="csrf-token"]').getAttribute("content");

    const $dropzoneElement = $("#idVerificationDrop");
    $dropzoneElement.dropzone({
        url: $dropzoneElement.data('route'),
        addRemoveLinks: true,
        removedfile: function (file) {
            $.ajax({
                type: 'DELETE',
                url: $dropzoneElement.data('route'),
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
            });
            var _ref;
            (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
        },
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        acceptedFiles: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
        maxFiles: 1,
        init: (function() {
            const existingFile = $dropzoneElement.data('existing-file');
            if(existingFile) {
                this.emit("addedfile", existingFile);
                this.emit("complete", existingFile);
                $dropzoneElement.find('.dz-progress').addClass('hide');
            }
        })
    });
})(jQuery);
